module.exports = __webpack_public_path__ + "static/img/CZ@2x.f97e3443.jpg";